import { useContext } from 'react';
import { companiesByIdSelector, CompanyFactory } from '@/domain/companies';
import { currentConnectedERPCompanyName } from '@/domain/settings';
import { organizationWhatsappPhoneSelector } from '@/domain/organization';
// eslint-disable-next-line no-restricted-syntax
import { loadedDataCompanyIdSelector } from '@/domain/documents';
import * as ACL from '@/domain/restriction';
import { useSelector } from 'react-redux';
import CompanyWorkspaceContext from '@/pages/company/WorkspaceRoute/CompanyWorkspaceContext';

const useAppbarCompanyLogo = () => {
  const { companyType } = useContext(CompanyWorkspaceContext);
  const companiesByID = useSelector(companiesByIdSelector);
  const erpCompanyName = useSelector(currentConnectedERPCompanyName);
  const orgWhatsappPhone = useSelector(organizationWhatsappPhoneSelector);
  const isGranted = useSelector(ACL.isGranted);
  // The header shows the company whose data the store holds — the last company visited, also
  // on the profile, whose URL names none — so that its name, logo and ERP name belong together.
  // A known compromise, to revisit together with the profile.
  const companyId = useSelector(loadedDataCompanyIdSelector);
  const company = companiesByID.get(companyId, CompanyFactory());
  const title = [company.cname];
  const email = companyType === 'confidential' ? company['email.confidential'] : company.email;
  const phone = company.whatsappPhone || orgWhatsappPhone;

  if (erpCompanyName) {
    title.push(`(${erpCompanyName})`);
  }

  return {
    name: title.join(' '),
    email,
    phone,
    src: company.logo,
    isAllowPhoneLink: !isGranted(ACL.IS_ACCOUNT),
  };
};

export default useAppbarCompanyLogo;
